import { render, staticRenderFns } from "./DropdownMenuItem.vue?vue&type=template&id=2709dc46&scoped=true&"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMenuItem.vue?vue&type=style&index=0&id=2709dc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2709dc46",
  null
  
)

export default component.exports